
import { Task } from '@/types/task';

export const sortTasksByCompletion = (tasks: Task[]) => {
  return [...tasks].sort((a, b) => {
    if (a.isCompleted !== b.isCompleted) {
      return a.isCompleted ? 1 : -1;
    }
    return 0;
  });
};

const getTimeInMinutes = (task: Task): number => {
  const hour = task.scheduledHour || 0;
  const minute = task.scheduledMinute || 0;
  return hour * 60 + minute;
};

export const sortTasksByTime = (tasks: Task[]) => {
  return [...tasks].sort((a, b) => {
    if (a.isCompleted !== b.isCompleted) {
      return a.isCompleted ? 1 : -1;
    }
    
    const aTime = getTimeInMinutes(a);
    const bTime = getTimeInMinutes(b);
    
    if (aTime > 0 && bTime > 0) {
      return aTime - bTime;
    }
    
    if (aTime > 0) return -1;
    if (bTime > 0) return 1;
    
    return 0;
  });
};

const getDayOrder = (day: string): number => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return days.indexOf(day);
};

export const getTasksByDay = (tasks: Task[], dateOffset: number) => {
  const tasksByDay: { [key: string]: Task[] } = {};
  const today = new Date().toLocaleDateString('en-US', { weekday: 'long' });

  tasks.forEach(task => {
    if (task.scheduledDay) {
      if (!tasksByDay[task.scheduledDay]) {
        tasksByDay[task.scheduledDay] = [];
      }
      tasksByDay[task.scheduledDay].push(task);
    }
  });

  Object.keys(tasksByDay).forEach(day => {
    tasksByDay[day] = sortTasksByTime(tasksByDay[day]);
  });

  // Sort days based on the standard day order (Sunday to Saturday)
  const sortedDays = Object.keys(tasksByDay)
    .sort((a, b) => {
      return getDayOrder(a) - getDayOrder(b);
    });

  const sortedTasksByDay: { [key: string]: Task[] } = {};
  sortedDays.forEach(day => {
    sortedTasksByDay[day] = tasksByDay[day];
  });

  return sortedTasksByDay;
};
